<template>
  <Button
    id="edit-button"
    severity="primary"
    aria-label="edit"
    v-tooltip.bottom="'Editar registro'"
    @click="toggleEditMode"
    outlined
  >
    <i v-if="!isEditMode" class="pi pi-pencil text-sm"></i>
    <i v-else class="pi pi-times text-sm"></i>
  </Button>
</template>
<script lang="ts" setup>
  import { ref } from 'vue'

  const isEditMode = ref(false)
  const emit = defineEmits(['update:isEditMode'])

  const toggleEditMode = () => {
    isEditMode.value = !isEditMode.value
    emit('update:isEditMode', isEditMode.value)
  }
</script>
